const POST_EMPLOYEE_DATA_START = 'POST_EMPLOYEE_DATA_START';
const POST_EMPLOYEE_DATA_SUCCESS = 'POST_EMPLOYEE_DATA_SUCCESS';
const POST_EMPLOYEE_DATA_ERROR = 'POST_EMPLOYEE_DATA_ERROR';
const GET_EMPLOYEE_DATA_START = 'GET_EMPLOYEE_DATA_START';
const GET_EMPLOYEE_DATA_SUCCESS = 'GET_EMPLOYEE_DATA_SUCCESS';
const GET_EMPLOYEE_DATA_ERROR = 'GET_EMPLOYEE_DATA_ERROR';
const POST_EMPLOYEE_DETAILS_START = 'POST_EMPLOYEE_DETAILS_START';
const POST_EMPLOYEE_DETAILS_SUCCESS = 'POST_EMPLOYEE_DETAILS_SUCCESS';
const POST_EMPLOYEE_DETAILS_ERROR = 'POST_EMPLOYEE_DETAILS_ERROR';
const POST_ADD_EMPLOYEE_START = ' POST_ADD_EMPLOYEE_START';
const POST_ADD_EMPLOYEE_SUCCESS = ' POST_ADD_EMPLOYEE_SUCCESS';
const POST_ADD_EMPLOYEE_ERROR = ' POST_ADD_EMPLOYEE_ERROR';
const GET_NATIONAL_DATA_START = 'GET_NATIONAL_DATA_START';
const GET_NATIONAL_DATA_SUCCESS = 'GET_NATIONAL_DATA_SUCCESS';
const GET_NATIONAL_DATA_ERROR = 'GET_NATIONAL_DATA_ERROR';
const DEL_EMPLOYEE_DATA_START = 'DEL_EMPLOYEE_DATA_START';
const DEL_EMPLOYEE_DATA_SUCCESS = 'DEL_EMPLOYEE_DATA_SUCCESS';
const DEL_EMPLOYEE_DATA_ERROR = 'DEL_EMPLOYEE_DATA_ERROR';
const GET_BANK_NAME_START = 'GET_BANK_NAME_START'; 
const GET_BANK_NAME_SUCCESS = 'GET_BANK_NAME_SUCCESS';
const GET_BANK_NAME_ERROR = 'GET_BANK_NAME_ERROR';
const GET_ORDER_CARD_START = 'GET_ORDER_CARD_START';
const GET_ORDER_CARD_SUCCESS = 'GET_ORDER_CARD_SUCCESS';
const GET_ORDER_CARD_ERROR = 'GET_ORDER_CARD_ERROR';
const GET_SALARY_TEMPLATE_START = 'GET_SALARY_TEMPLATE_START';
const GET_SALARY_TEMPLATE_SUCCESS = 'GET_SALARY_TEMPLATE_SUCCESS';
const GET_SALARY_TEMPLATE_ERROR = 'GET_SALARY_TEMPLATE_ERROR';
const POST_UPLOAD_DATA_START = 'POST_UPLOAD_DATA_START';
const POST_UPLOAD_DATA_SUCCESS = ' POST_UPLOAD_DATA_SUCCESS';
const POST_UPLOAD_DATA_ERROR = 'POST_UPLOAD_DATA_ERROR';

const postuploadStart = (params) => {
	return {
		type: POST_UPLOAD_DATA_START,
		params,
	};
};

const postuploadSuccess = (res) => {
	return {
		type: POST_UPLOAD_DATA_SUCCESS,
		res,
	};
};

const postuploadError = () => {
	return {
		type: POST_UPLOAD_DATA_ERROR,
	};
};

const postemployeeStart = (params) => {
	return {
		type: POST_EMPLOYEE_DATA_START,
		params,
	};
};

const postemployeeSuccess = (res) => {
	return {
		type: POST_EMPLOYEE_DATA_SUCCESS,
		res,
	};
};

const postemployeeError = () => {
	return {
		type: POST_EMPLOYEE_DATA_ERROR,
	};
};
const getemployeeStart = (res) => {
	return {
		type: GET_EMPLOYEE_DATA_START,
		res,
	};
};

const getemployeeSuccess = (res) => {
	return {
		type: GET_EMPLOYEE_DATA_SUCCESS,
		res,
	};
};

const getemployeeError = () => {
	return {
		type: GET_EMPLOYEE_DATA_ERROR,
	};
};
const delemployeeStart = (res, requestParams) => {
	return {
		type: DEL_EMPLOYEE_DATA_START,
		res,
		requestParams,
	};
};

const delemployeeSuccess = (res) => {
	return {
		type: DEL_EMPLOYEE_DATA_SUCCESS,
		res,
	};
};

const delemployeeError = () => {
	return {
		type: DEL_EMPLOYEE_DATA_ERROR,
	};
};
const getnationalStart = (res) => {
	return {
		type: GET_NATIONAL_DATA_START,
		res,
	};
};

const getnationalSuccess = (res) => {
	return {
		type: GET_NATIONAL_DATA_SUCCESS,
		res,
	};
};

const getnationalError = () => {
	return {
		type: GET_NATIONAL_DATA_ERROR,
	};
};

const postdetailsStart = (params) => {
	return {
		type: POST_EMPLOYEE_DETAILS_START,
		params,
	};
};

const postdetailsSuccess = (res) => {
	return {
		type: POST_EMPLOYEE_DETAILS_SUCCESS,
		res,
	};
};

const postdetailsError = () => {
	return {
		type: POST_EMPLOYEE_DETAILS_ERROR,
	};
};
const postaddStart = (params, requestParams, isAdd, etype) => {
	return {
		type: POST_ADD_EMPLOYEE_START,
		params,
		requestParams,
		isAdd,
		etype,
	};
};

const postaddSuccess = (res) => {
	return {
		type: POST_ADD_EMPLOYEE_SUCCESS,
		res,
	};
};

const postaddError = () => {
	return {
		type: POST_ADD_EMPLOYEE_ERROR,
	};
};
const getbanknameStart = (res) => {
	return {
		type: GET_BANK_NAME_START,
		res,
	};
};

const getbanknameSuccess = (res) => {
	return {
		type: GET_BANK_NAME_SUCCESS,
		res,
	};
};

const getbanknameError = () => {
	return {
		type: GET_BANK_NAME_ERROR,
	};
};
const getordercardStart = (res) => {
	return {
		type: GET_ORDER_CARD_START,
		res,
	};
};
const getordercardSuccess = (res) => {
	return {
		type: GET_ORDER_CARD_SUCCESS,
		res,
	};
};
const getordercardError = () => {
	return {
		type: GET_ORDER_CARD_ERROR,
	};
};
const getsalarytemplateStart = (res) => {
	return {
		type: GET_SALARY_TEMPLATE_START,
		res,
	};
};
const getsalarytemplateSuccess = (res) => {
	return {
		type: GET_SALARY_TEMPLATE_SUCCESS,
		res,
	};
};
const getsalarytemplateError = () => {
	return {
		type: GET_SALARY_TEMPLATE_ERROR,
	};
};
export default {
	types: {
		POST_EMPLOYEE_DATA_START,
		POST_EMPLOYEE_DATA_SUCCESS,
		POST_EMPLOYEE_DATA_ERROR,
		GET_EMPLOYEE_DATA_START,
		GET_EMPLOYEE_DATA_SUCCESS,
		GET_EMPLOYEE_DATA_ERROR,
		POST_EMPLOYEE_DETAILS_START,
		POST_EMPLOYEE_DETAILS_SUCCESS,
		POST_EMPLOYEE_DETAILS_ERROR,
		POST_ADD_EMPLOYEE_START,
		POST_ADD_EMPLOYEE_SUCCESS,
		POST_ADD_EMPLOYEE_ERROR,
		GET_NATIONAL_DATA_START,
		GET_NATIONAL_DATA_SUCCESS,
		GET_NATIONAL_DATA_ERROR,
		DEL_EMPLOYEE_DATA_START,
		DEL_EMPLOYEE_DATA_SUCCESS,
		DEL_EMPLOYEE_DATA_ERROR,
		GET_BANK_NAME_START,
		GET_BANK_NAME_SUCCESS,
		GET_BANK_NAME_ERROR,
		GET_ORDER_CARD_START,
		GET_ORDER_CARD_SUCCESS,
		GET_ORDER_CARD_ERROR,
		GET_SALARY_TEMPLATE_START,
		GET_SALARY_TEMPLATE_SUCCESS,
		GET_SALARY_TEMPLATE_ERROR,
		POST_UPLOAD_DATA_START,
		POST_UPLOAD_DATA_SUCCESS,
		POST_UPLOAD_DATA_ERROR,
	},
	creators: {
		postuploadStart,
		postuploadSuccess,
		postuploadError,
		postemployeeStart,
		postemployeeSuccess,
		postemployeeError,
		getemployeeStart,
		getemployeeSuccess,
		getemployeeError,
		postdetailsStart,
		postdetailsSuccess,
		postdetailsError,
		postaddStart,
		postaddSuccess,
		postaddError,
		getnationalStart,
		getnationalSuccess,
		getnationalError,
		delemployeeStart,
		delemployeeSuccess,
		delemployeeError,
		getbanknameStart,
		getbanknameSuccess,
		getbanknameError,
		getordercardStart,
		getordercardSuccess,
		getordercardError,
		getsalarytemplateStart,
		getsalarytemplateSuccess,
		getsalarytemplateError,
	},
};
